module.exports = __webpack_public_path__ + "img/ic_12_down_white.da51a31f.svg";